import { differenceInCalendarDays, startOfDay, format } from 'date-fns';
import { pl } from 'date-fns/locale';

export const formatDaysSinceLastContact = (dateStr) => {
  if (!dateStr) return '—';

  try {
    const contactDate = startOfDay(new Date(dateStr));
    const today = startOfDay(new Date());
    const days = differenceInCalendarDays(today, contactDate);

    if (days < 0) return '—';
    if (days === 0) return 'Dziś';
    if (days === 1) return '1 dzień';

    return `${days} dni`;
  } catch {
    return '—';
  }
};

export const formatLastContactTooltip = (dateStr) => {
  if (!dateStr) return '';
  try {
    return format(new Date(dateStr), 'dd MMM yyyy', { locale: pl });
  } catch {
    return dateStr;
  }
};
